import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import TipsWidget from 'components/TipsWidget';
import AlertWidget from 'components/AlertWidget';
import DailyBudgetInput from 'components/DailyBudgetInput';
import { Card, CardTitle, CardContent } from 'components/Card';

import { dollarToCent } from '../../../campaign/components/CampaignDetails/CampaignDetails';

export class EditStandardAdsForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            campaignCurrency: props.campaignCurrency,
            campaignDailyBudget: props.campaignDailyBudget || 0,
            campaignDailyBudgetErrors: [],
        };

        this.validateCampaignFieldAsync = (() => {
            let timer = null;
            /** @var {null|number} -  time start */
            let ts = null;
            /** @var {number} -  time delta */
            const td = 600;
            return (...args) =>
                new Promise((resolve) => {
                    /** @var {number} - time delta */
                    let d;
                    clearTimeout(timer);
                    if (ts === null) {
                        ts = Date.now();
                        d = td;
                    } else {
                        d = Date.now() - (ts + td);
                    }
                    timer = setTimeout(
                        () => {
                            resolve(this.validateCampaignField(...args));
                            ts = null;
                            timer = null;
                        },
                        d <= 0 ? 0 : d,
                    );
                });
        })();

        this.changeCampaignField = this.changeCampaignField.bind(this);
        this.validateCampaignField = this.validateCampaignField.bind(this);
        this.setMinimumDailyBudget = this.setMinimumDailyBudget.bind(this);
        this.onCampaignCreateFormSubmit = this.onCampaignCreateFormSubmit.bind(this);
        this.handleCampaignFieldAsyncValidation = this.handleCampaignFieldAsyncValidation.bind(this);
    }

    changeCampaignField(e) {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
        });
        this.handleCampaignFieldAsyncValidation(name, value);
    }

    setMinimumDailyBudget() {
        const { campaignMinBudget, handleFormError } = this.props;
        this.setState({
            campaignDailyBudget: campaignMinBudget,
            campaignDailyBudgetErrors: [],
        });
        handleFormError(false);
    }

    validateCampaignField(name, value) {
        const errors = [];
        switch (name) {
            case 'campaignDailyBudget': {
                if (value.length === 0) {
                    errors.push('blank');
                }
                const num = parseFloat(value);
                if (!/^[-+]{0,1}[0-9]+\.{0,1}[0-9]{0,}$/.test(value) || isNaN(num)) {
                    errors.push('number');
                }
                const minimalDailyBudget = this.props.campaignMinBudget;
                if (num < minimalDailyBudget) {
                    errors.push('lower');
                }
                break;
            }
            default:
                break;
        }
        return {
            [`${name}Errors`]: errors,
        };
    }

    hasCampaignFormErrors() {
        return this.state.campaignDailyBudgetErrors.length !== 0;
    }

    handleCampaignFieldAsyncValidation(name, value) {
        this.validateCampaignFieldAsync(name, value).then((fieldErrorState) => {
            const { handleFormError } = this.props;

            const hasErrors = this.hasCampaignFormErrors.apply({
                state: {
                    ...this.state,
                    ...fieldErrorState,
                },
            });

            this.setState({
                ...fieldErrorState,
            });

            handleFormError(hasErrors);
        });
    }

    onCampaignCreateFormSubmit(e) {
        e.preventDefault();
        const { saveCampaign } = this.props;
        const { campaignDailyBudget } = this.state;
        const dailyBudget = dollarToCent(campaignDailyBudget);
        if (dailyBudget instanceof Error) {
            const err = dailyBudget;
            this.setState({
                campaignDailyBudgetErrors: [err.message],
            });
            return;
        }

        saveCampaign(dailyBudget);
    }

    render() {
        const { formName, disabled, campaignMinBudget } = this.props;
        let dailyBudgetAlert = '';

        const dailyBudgetErrors = this.state.campaignDailyBudgetErrors;
        if (dailyBudgetErrors.length) {
            if (dailyBudgetErrors.includes('lower') || dailyBudgetErrors.includes('blank')) {
                dailyBudgetAlert = (
                    <AlertWidget color="danger">
                        <p className="alert-description__item">
                            Minimum Daily Budget is {campaignMinBudget.toFixed(2)} {this.state.campaignCurrency}.
                        </p>
                        <button
                            type="button"
                            className="alert-description__link_highlighted"
                            onClick={this.setMinimumDailyBudget}
                        >
                            Set {campaignMinBudget.toFixed(2)} {this.state.campaignCurrency}
                        </button>
                    </AlertWidget>
                );
            }
        }

        return (
            <Card className="google-ads-form">
                <form id={formName} onSubmit={this.onCampaignCreateFormSubmit}>
                    {dailyBudgetAlert}
                    <CardTitle subTitle labelFor="dbInput">
                        <span>Daily Budget</span>
                        <TipsWidget placement="top" isDarkView>
                            <p className="tips-description__content">
                                Daily budget is the maximum amount of money you are ready to spend on your retargeting
                                ads within a 24-hour period.
                            </p>
                            <p className="tips-description__content">
                                <a
                                    href={
                                        'https://help.adwisely.com' +
                                        '/learn-about-pricing-privacy-policy-and-terms' +
                                        '/whats-the-cost-of-retargetapp'
                                    }
                                    className="link link-white"
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    I want to learn more &#x2192;
                                </a>
                            </p>
                        </TipsWidget>
                    </CardTitle>
                    <CardContent>
                        <DailyBudgetInput
                            dailyBudget={this.state.campaignDailyBudget.toString()}
                            dailyBudgetCurrency={this.state.campaignCurrency}
                            onChange={this.changeCampaignField}
                            onFocus={this.changeCampaignField}
                            disabled={disabled}
                            dailyBudgetHasErrors={!!dailyBudgetErrors.length}
                        />
                    </CardContent>
                </form>
            </Card>
        );
    }
}

EditStandardAdsForm.defaultProps = {
    disabled: false,
};

EditStandardAdsForm.propTypes = {
    campaignCurrency: PropTypes.string.isRequired,
    campaignDailyBudget: PropTypes.number.isRequired,
    campaignMinBudget: PropTypes.number.isRequired,
    disabled: PropTypes.bool,
    formName: PropTypes.string.isRequired,
    handleFormError: PropTypes.func.isRequired,
    saveCampaign: PropTypes.func.isRequired,
};

const mapStateToProps = ({ shopError }) => ({
    shopError: shopError.shopError,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(EditStandardAdsForm);
